module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "warn"
  }, [_c('div', {
    staticClass: "content"
  }, [_c('span', [_vm._v(_vm._s(_vm.params[_vm.type].text))]), _vm._v(" "), _c('span', {
    staticStyle: {
      "color": "#3f86de",
      "cursor": "pointer"
    },
    on: {
      "click": _vm.clickRouter
    }
  }, [_vm._v(_vm._s(_vm.params[_vm.type].router))])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-62c5891a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/new-login-2018/components/Warn.vue
// module id = 730
// module chunks = 1